import { Controller } from 'stimulus';
import { debounce } from 'lodash-es';

// Connects to data-controller="operative-search"
// Generic operative autocomplete: queries the endpoint in the `url` value and
// writes the chosen operative's id into the `userId` hidden-field target.
export default class extends Controller {
  static targets = ['input', 'results', 'userId'];
  static values = { url: String };

  connect() {
    this.debouncedSearch = debounce(this.search.bind(this), 500);
    this.boundClickOutside = this.handleClickOutside.bind(this);

    this.inputTarget.addEventListener('keyup', this.debouncedSearch);
    document.addEventListener('click', this.boundClickOutside);
  }

  disconnect() {
    this.inputTarget.removeEventListener('keyup', this.debouncedSearch);
    document.removeEventListener('click', this.boundClickOutside);
  }

  search() {
    const query = this.inputTarget.value.trim();

    if (this.hasUserIdTarget) this.userIdTarget.value = '';

    if (query.length < 3) {
      this.hideResults();
      return;
    }

    const url = `${this.urlValue}?query=${encodeURIComponent(query)}`;

    fetch(url, {
      method: 'GET',
      headers: { Accept: 'text/vnd.turbo-stream.html' },
    })
      .then((response) => response.text())
      .then((html) => {
        this.resultsTarget.innerHTML = html;
      });
  }

  selectResult(event) {
    const { userId, userFullNameId } = event.currentTarget.dataset;

    if (this.hasUserIdTarget) this.userIdTarget.value = userId;
    this.inputTarget.value = userFullNameId;

    this.hideResults();
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) this.hideResults();
  }

  hideResults() {
    this.resultsTarget.innerHTML = '';
  }
}
